import { render } from "./AddVacationTemplateDetails.vue?vue&type=template&id=f535d5be"
import script from "./AddVacationTemplateDetails.vue?vue&type=script&lang=js"
export * from "./AddVacationTemplateDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__